import { User } from "views/settings-users/slices/users/types";

export enum NotificationKind {
  Mention = "mention",
  Assigned = "assigned",
  Message = "message",
  Call = "call"
}
export enum NotificationType {
  TaskMention = "mentioned_in_tasks",
  TaskNoteMention = "mentioned_in_task_notes",
  ApplicationNotesMention = "mentioned_in_application_notes",
  LeadNotesMention = "mentioned_in_lead_notes",
  AssignedTask = "task_assigned",
  DueTask = "task_due_soon",
  LeadAssigned = "lead_assigned",
  ApplicationAssigned = "application_assigned",
  InboxMessage = "inbox_message",
  InboxMessageDigest = "inbox_message_digest",
  MissedCall = "missed_call"
}

export enum InboxMessageChannel {
  Email = "email",
  Sms = "sms",
  Chat = "chat"
}
export interface Notification {
  id: number;
  kind: NotificationKind;
  created_at: string;
  type: NotificationType;
  user: User;
  author?: User | string;
  read_at: string | null;
  url: string;
  updated_at: string;
  rich_text?: {
    document_html: string;
    document_text: string;
  } | null;
  metadata: {
    rich_text_id?: number;
    application_id?: number | null;
    rich_text_field?: "title" | "description";
    note_id?: number;
    task_id?: number | null;
    lead_id?: number | null;
    // inbox_message metadata
    channel?: InboxMessageChannel;
    conversation_id?: string;
    contact_id?: number;
    message_id?: string;
    preview?: string;
    sender_name?: string;
    property_name?: string;
    // inbox_message_digest metadata
    count?: number;
    channels?: InboxMessageChannel[];
    conversation_ids?: string[];
    window_start?: string;
    window_end?: string;
    messages?: Array<{
      conversation_id?: string;
      channel?: InboxMessageChannel;
      preview?: string;
      sender_name?: string;
      property_name?: string;
      occurred_at?: string;
      read_at?: string | null;
    }>;
    // missed_call metadata (CRM-1235). `from_number` is the caller — the number
    // "Call back" dials; `to_name` is the partner-side label the title reads as
    // "Missed call at {to_name}". `ring_seconds` is ended_at - started_at, not
    // Twilio's CallDuration, which is 0 for an unanswered call.
    call_id?: number;
    customer_id?: number | null;
    from_number?: string;
    to_number?: string;
    from_name?: string | null;
    to_name?: string | null;
    occurred_at?: string;
    ring_seconds?: number | null;
    status?: string;
    direction?: string;
  };
}

export interface MarkAllAsReadRequest {
  kind: NotificationKind;
}

export interface MarkAllAsReadResponse {
  count: number;
  total_unread: number;
}

export interface NotificationGroup {
  name: string;
  items: Notification[];
}
